export default __webpack_public_path__ + "static/media/mama.6215bfcd.jpg";